import React from "react";

import _ from "lodash";
import PropTypes from "prop-types";
import BootstrapTable from "react-bootstrap/Table";
import { useIntl } from "react-intl";
import * as uuid from "uuid";
import ObjectUtils from "../../../../utils/ObjectUtils";
import { formatNumber, formatPercentage } from "./NumberFormatUtils";

const HorizontalTable = ({ data, subQuestionDetails, firstColumnTitle, percentage, tableId, useZAxisValue }) => {
  const intl = useIntl();
  const getXAxisLabel = (entry) => entry?.xaxisInfo || entry?.xaxisValue;

  const tableHeaderRows =
    subQuestionDetails &&
    Object.keys(_.groupBy(subQuestionDetails, "xaxisValue")).sort((a, b) => {
      if (data?.data.findIndex((d) => d.xaxisValue === a) === -1) {
        return 9999;
      } else {
        return data?.data.findIndex((d) => d.xaxisValue === a) - data?.data.findIndex((d) => d.xaxisValue === b);
      }
    });
  const newArray = _.groupBy(subQuestionDetails, "zaxisValue");
  return (
    <BootstrapTable responsive striped bordered hover className="horizontal" id={tableId}>
      <thead>
        <tr>
          <th title={firstColumnTitle && typeof firstColumnTitle === "string" ? firstColumnTitle : null}>{firstColumnTitle ? firstColumnTitle : null}</th>
          {tableHeaderRows
            ? tableHeaderRows.map((d) => {
                const entry =
                  data?.data.find((detail) => detail.xaxisValue === d) ||
                  subQuestionDetails.find((detail) => detail.xaxisValue === d);
                const label = getXAxisLabel(entry) || d;
                return <th key={uuid.v4()} title={label}>{label}</th>;
              })
            : data?.data.map((d) => {
                const label = getXAxisLabel(d);
                return label ? <th key={uuid.v4()} title={label}>{label}</th> : <th key={uuid.v4()}>{"-"}</th>;
              })}
        </tr>
      </thead>
      <tbody>
        {newArray
          ? Object.keys(newArray).map((key) => {
              return (
                <tr key={uuid.v4()}>
                  <td title={newArray[key][0].zaxisInfo}>
                    {useZAxisValue ? key : newArray[key][0].zaxisInfo || key}
                  </td>
                  {tableHeaderRows?.map((row, index) => {
                    let e = ObjectUtils.findByObjectProp(newArray[key], "xaxisValue", row);
                    const sum = data?.data[index]?.yaxisValue;
                    const value =
                      percentage && sum
                        ? isNaN(e.yaxisValue)
                          ? e.yaxisValue
                          : formatPercentage((e.yaxisValue / sum) * 100)
                        : formatNumber(e.yaxisValue);
                    return (
                      <td key={uuid.v4()} title={getXAxisLabel(e)} className={e.yaxisValue ? "description" : ""}>
                        {value ? value : "0"}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          : null}

        <tr className="bg-light">
          <th>{intl.formatMessage({ id: "collapsible.table.question.total" })}</th>
          {tableHeaderRows
            ? tableHeaderRows.map((row, index) => {
                const sum = data?.data[index]?.yaxisValue;
                return sum ? (
                  <th key={uuid.v4()}>
                    {formatNumber(sum)} {percentage ? " (100%)" : ""}
                  </th>
                ) : (
                  <th key={uuid.v4()}>{"-"}</th>
                );
              })
            : data?.data.map((d) => {
                return d.yaxisValue ? (
                  <th key={uuid.v4()}>
                    {formatNumber(d.yaxisValue)} {percentage ? " (100%)" : ""}
                  </th>
                ) : (
                  <th key={uuid.v4()}>{"-"}</th>
                );
              })}
        </tr>
      </tbody>
    </BootstrapTable>
  );
};

HorizontalTable.propTypes = {
  subQuestionDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  data: PropTypes.object,
  useZAxisValue: PropTypes.bool
};

export default HorizontalTable;
